(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ 3137:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(21902);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/v5/About/AboutUs.tsx
var AboutUs = __webpack_require__(15897);
// EXTERNAL MODULE: ./src/components/v5/About/Careers.tsx + 1 modules
var Careers = __webpack_require__(3497);
// EXTERNAL MODULE: ./src/components/v5/About/CoreValues.tsx
var CoreValues = __webpack_require__(77544);
// EXTERNAL MODULE: ./src/components/v5/About/Hero.tsx
var Hero = __webpack_require__(4448);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./src/components/v5/About/SectionHeader.tsx
var SectionHeader = __webpack_require__(9978);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
;// CONCATENATED MODULE: ./src/components/v5/Careers/OurBenefits.tsx






const OurBenefits = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const data = [
        {
            header: i18n.t("Comprehensive health & wellness plans"),
            text: i18n.t("We offer programs and resources to support your overall health and well-being."),
            img: "illustrations/happy-healthy-person-smiling",
            alt: i18n.t("Illustration of a happy healthy person smiling.")
        },
        {
            header: i18n.t("Competitive compensation & perks"),
            text: i18n.t("We are committed to ensuring fair and equitable pay for all employees."),
            img: "/illustrations/piggy-bank",
            alt: i18n.t("Illustration of a hand dropping a coin into a piggy bank.")
        },
        {
            header: i18n.t("Collaborative & inclusive culture"),
            text: i18n.t("We value the minds, experiences, and perspectives of people from all walks of life."),
            img: "illustrations/hands",
            alt: i18n.t("Illustration of hands coming together in a team cheer formation.")
        },
        {
            header: i18n.t("Career growth & development"),
            text: i18n.t("We want to empower you with tools, resources, and feedback to help you reach new heights."),
            img: "illustrations/laptop-with-cactus",
            alt: i18n.t("Illustration of a small plant and an open laptop with a positive growth graph on the screen.")
        },
        {
            header: i18n.t("Learning resources to be your best self"),
            text: i18n.t("Our ongoing learning opportunities, including Udemy Business and Learning Time Off program, support your personal and professional growth."),
            img: "illustrations/person-at-laptop",
            alt: i18n.t("Illustration of a person sitting in front of their laptop taking notes.")
        },
        {
            header: i18n.t("Work from clinic, home, or office"),
            text: i18n.t("With remote, on-site, and hybrid roles, our flexible work culture is designed to accommodate your unique needs and lifestyle, so you can be successful in your role."),
            img: "illustrations/person-in-wheelchair-with-computer",
            alt: i18n.t("Illustration of a person in a wheelchair, sitting at a table, working on their laptop.")
        }
    ];
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ph8 pt8 pb18",
        style: isSm ? {
            "--w": 200
        } : {},
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "maxw80 ma df fdc",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                    tag: i18n.t("Life at Carbon Health"),
                    header: i18n.t("Our benefits")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "dg af gg10 mt14",
                    children: data.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df fdc maxw22 mb12 mb0-sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                        src: item.img,
                                        height: isSm ? 140 : 190,
                                        width: isSm ? 140 : 190,
                                        alt: item.alt
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ls-3 fs28 font-cm mb3 lh12",
                                    children: item.header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-im gray600 lh14",
                                    children: item.text
                                })
                            ]
                        }, item.img))
                })
            ]
        })
    });
};
/* harmony default export */ var Careers_OurBenefits = (OurBenefits);

// EXTERNAL MODULE: ./src/components/v5/IllustratedTextDecoration.tsx
var IllustratedTextDecoration = __webpack_require__(46452);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
;// CONCATENATED MODULE: ./src/pages/careers.tsx













const careers_Careers = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [jobs, setJobs] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        fetch(_constants/* LEVER_URI */.LK).then((res)=>res.json()).catch((err)=>{
            esm_exports/* captureException */.Tb(err);
            return [];
        }).then((list)=>{
            setJobs(list);
        });
    }, []);
    const subheader = /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_i18n/* Trans */.cC, {
        children: [
            "We're on a mission to make high-quality healthcare accessible",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "pos-r zIndex1",
                children: [
                    "for all.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IllustratedTextDecoration/* IllustratedTextDecoration */.S, {
                        type: "double-yellow-underline"
                    })
                ]
            })
        ]
    });
    const caption = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "white df fdc aife font-ir lh13",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-ib",
                children: "Norma"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: i18n.t("Senior Manager of Public Partnerships")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: i18n.t("Operations & Implementation")
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: i18n.t("Take The Next Step in Your Career With Carbon Health"),
        pageDescription: i18n.t("Looking for a new career opportunity? Explore all the jobs available at Carbon Health. Let’s work together to make high-quality healthcare accessible to all."),
        ogAlt: i18n.t("Carbon Health is making good health accessible to everyone. Join us."),
        pageImage: "join-us",
        navTheme: useNavState/* NavTheme.LIGHT */.Xm.LIGHT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                h1: i18n.t("Come work with us"),
                subheader: subheader,
                jobCount: jobs.length,
                img: "/careers/norma",
                alt: i18n.t("Photo of Norma, one of our staff members, standing outside smiling."),
                caption: caption,
                backgroundPosition: "80% 50%"
            }),
            jobs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Careers/* default */.Z, {
                jobs: jobs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs/* default */.Z, {
                hideStory: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Careers_OurBenefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreValues/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var careers = (careers_Careers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,4690,6282,2122,5280,9774,2888,179], function() { return __webpack_exec__(3137); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);